import axios from 'axios';

const API_KEY = process.env.REACT_APP_NEWS_API_KEY;
export default axios.create({
  baseURL: `https://api.nytimes.com/svc/search/v2/articlesearch.json?api-key=${API_KEY}&`,
  params: {
    q: 'covid-19'
  }
});
